import clsx, { ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

import { colors, fontSizes } from '@/styles/types';

// Why? Because tailwind-merge doesn't support custom class groups by default so we have to define them
// Example issue: "text-body-l text-neutral-N90" becomes "text-body-l"
// TODO add support for existing text classes like text-[0.5rem] because it does causes the same issue
const customTwMerge = extendTailwindMerge({
  classGroups: {
    'bg-color': [{ bg: colors }],
    'font-size': [{ text: fontSizes }],
    'border-color': [{ border: colors }],
    'shadow-color': [{ shadow: colors }],
    shadow: [{ shadow: ['card', 'popup', 'tiny', 'border-px'] }],
    'text-wrap': [{ text: ['nowrap', 'truncate', 'wrap'] }],
  },
});

/** Merge classes with tailwind-merge with clsx full feature */
export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}

export function obfuscate(string: string) {
  if (!string) return '';
  if (string.length < 5) return '***';

  return string.slice(0, 5).concat('...');
}

/** Removes CMS `id` fields so they are not rendered as HTML `id` attributes. */
export function stripNonHtmlIds<T extends { id?: unknown }>(
  value: T
): Omit<T, 'id'> {
  const { id: _id, ...rest } = value;
  return rest;
}
